module.exports = __webpack_public_path__ + "static/media/TN-Men-Bags.f3261479.svg";